import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import SidebarContainer from '../SidebarContainer';
import dealersActions from '../../redux/dealers/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';
import './Pricing.scss';

import { PricingEditor } from '../../components/PricingEditor';
import DealerNav from '../../components/DealerNav';

class Pricing extends Component {
  componentDidMount() {
    const { dealerId } = this.props.match.params;
    this.props.actions.dealerYMMTRequest(dealerId);
  }

  onSave = payload => {
    const { dealerId } = this.props.match.params;
    this.props.actions.updateDealerRequest({
      ...payload,
      route: `/${dealerId}/pricing`,
    });
  };

  setStep = step => {
    const { dealerId } = this.props.match.params;
    this.props.history.push(`/${dealerId}/pricing/${step}`);
  };

  render() {
    const { step } = this.props.match.params;
    const { dealers } = this.props;
    const { dealer, error, fetching, ymmt } = dealers;
    return (
      <SidebarContainer
        title={dealer.name ? dealer.name : 'Create a Pricing'}
        logo={dealer.logo}
      >
        <div className="dealers-table">
          <DealerNav />
          {error && <ErrorMessage error={error} />}
          {dealer.id && (
            <PricingEditor
              dealer={dealer}
              ymmt={ymmt || { years: [] }}
              fetching={fetching}
              step={parseInt(step, 10)}
              onSave={this.onSave}
              setStep={this.setStep}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Pricing.propTypes = {
  actions: PropTypes.object,
  dealers: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ dealers }) => ({
  dealers,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(dealersActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(Pricing));
